<template>
    <v-layout
            column
            wrap
            class="my-12"
            align-center
    >
        <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
                <h2 class="headline">Wir rekrutieren</h2>
                <span class="subheading">
               Wir sind ein Kriegsclan und nehmen daher nur aktive und an Clankriegen interessierte, sowie erfahrene Spieler auf.
              </span>
            </div>
        </v-flex>
        <v-flex xs12>
            <v-container grid-list-xl>
                <v-layout row wrap align-center>
                    <v-flex xs12 md4 class="hidden-md-and-up">
                        <v-card flat class="transparent" min-height="150px" max-height="250">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Allgemein</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>über 18 Jahre alt</li>
                                    <li>mindestens 500 Clankriegssterne</li>
                                    <li>Angriffserfahren</li>
                                    <li>Hilfsbereit & sozial</li>
                                    <li>dem Rathaus entsprechende Verteidigungsgebäude</li>
                                </ul>


                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4  class="hidden-md-and-up">
                        <v-card flat class="transparent" min-height="150px" max-height="250">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">Rathaus 11</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Königin Level 40</li>
                                    <li>König Level 40</li>
                                    <li>Wächter Level 15</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4  class="hidden-md-and-up">
                        <v-card flat class="transparent" min-height="150px" max-height="250">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Rathaus 12</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Königin Level 50</li>
                                    <li>König Level 50</li>
                                    <li>Wächter Level 20</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-center class="hidden-sm-and-down">
                    <v-flex xs12 md4>
                        <v-card flat class="transparent" height="20vw" max-height="300px">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Allgemein</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>über 18 Jahre alt</li>
                                    <li>mindestens 500 Clankriegssterne</li>
                                    <li>Angriffserfahren</li>
                                    <li>Hilfsbereit & sozial</li>
                                    <li>dem Rathaus entsprechende Verteidigungsgebäude</li>
                                </ul>


                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 class="hidden-sm-and-down">
                        <v-card flat class="transparent" height="20vw" max-height="300px">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">Rathaus 11</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Königin Level 40</li>
                                    <li>König Level 40</li>
                                    <li>Wächter Level 15</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 class="hidden-sm-and-down">
                        <v-card flat class="transparent" height="20vw" max-height="300px">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Rathaus 12</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Königin Level 50</li>
                                    <li>König Level 50</li>
                                    <li>Wächter Level 20</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
</template>
<script>
    export default {
        name: 'Recruit',
        data: () => ({

        }),
    };

</script>
